import React from "react";
import { Typography } from "@mui/material";

export const GridHeaderFactory = (
  section: string,
  color?: string,
  icon?: JSX.Element,
) => {
  const GridHeader = () => (
    <Typography
      variant="subtitle1"
      sx={{
        pl: 1,
        pt: 0.5,
        pb: 0.5,
        backgroundColor: color ? color : "#1c1c1c",
      }}
    >
      {section} {icon}
    </Typography>
  );
  return GridHeader;
};
